import { render, staticRenderFns } from "./labelInfo.vue?vue&type=template&id=7264e5a1&scoped=true&"
import script from "./labelInfo.vue?vue&type=script&lang=js&"
export * from "./labelInfo.vue?vue&type=script&lang=js&"
import style0 from "./labelInfo.vue?vue&type=style&index=0&id=7264e5a1&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7264e5a1",
  null
  
)

export default component.exports